import { Button, DatePicker } from "antd";
import dayjs from "dayjs";
import React from "react";
import { disabledDate } from "../../util/functions";

const CustomDateRange = ({
  dates = {},
  setDates,
  isdDisableData = true,
  allowClear = true,
}) => {
  const { RangePicker } = DatePicker;

  const dateFilterFunction = (e) => {
    console.log(e);

    if (e) {
      setDates({
        startDate: dayjs(e[0])?.format("YYYY-MM-DD"),
        endDate: dayjs(e[1])?.format("YYYY-MM-DD"),
      });
    } else {
      setDates({
        startDate: null,
        endDate: null,
      });
    }
  };
  return (
    <>
      <RangePicker
        disabledDate={isdDisableData ? disabledDate : false}
        className="w-[270px]"
        allowClear={allowClear}
        onChange={dateFilterFunction}
        value={
          dates?.startDate && dates?.endDate
            ? [dayjs(dates?.startDate), dayjs(dates?.endDate)]
            : []
        }
        renderExtraFooter={() => (
          <div className="flex gap-2">
            <Button
              type="link"
              onClick={() => dateFilterFunction([dayjs(), dayjs()])}
            >
              Today
            </Button>
            <Button
              type="link"
              onClick={() =>
                dateFilterFunction([dayjs().subtract(7, "days"), dayjs()])
              }
            >
              7 Days
            </Button>
            <Button
              type="link"
              onClick={() =>
                dateFilterFunction([dayjs().subtract(30, "days"), dayjs()])
              }
            >
              30 Days
            </Button>
            <Button type="link" onClick={() => dateFilterFunction(null)}>
              All Time
            </Button>
          </div>
        )}
      />
    </>
  );
};

export default CustomDateRange;
